import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-setting" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "title-setting" }, "Configurações", -1)
const _hoisted_3 = { class: "container-setting-table" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Gerenciar permissões de acesso"),
  /*#__PURE__*/_createElementVNode("h3", null, "Aqui você pode definir os acessos que cada usuário terá.")
], -1)
const _hoisted_6 = { class: "dataList" }
const _hoisted_7 = { class: "dropdown" }
const _hoisted_8 = {
  class: "btn btn-transparent",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_9 = {
  id: "scroll-container",
  class: "d-flex align-items-end"
}
const _hoisted_10 = { style: {"margin-left":"15px"} }
const _hoisted_11 = {
  class: "dropdown-menu dropdown-menu-lg-end",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "dropdown-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_settings_modal = _resolveComponent("settings-modal")!
  const _component_TableSetting = _resolveComponent("TableSetting")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.activeFilter(_ctx.filters)), 1),
                    _createElementVNode("span", _hoisted_10, [
                      _createVNode(_component_BaseIcon, {
                        name: "chevron-down-dark",
                        size: "14px"
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("ul", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: filter[0],
                  onClick: ($event: any) => (_ctx.toggleFilter(filter))
                }, [
                  _createElementVNode("a", _hoisted_13, _toDisplayString(filter.text), 1)
                ], 8, _hoisted_12))
              }), 128))
            ])
          ]),
          _createElementVNode("input", {
            class: "dataList-input",
            id: "dataList-input",
            type: "text",
            list: "datalist",
            placeholder: "Pesquisar usuários",
            onKeyup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlevalue && _ctx.handlevalue(...args)))
          }, null, 32),
          _createElementVNode("label", {
            class: "dataList-icon",
            for: "dataList-input",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, [
            _createVNode(_component_BaseIcon, {
              name: "search",
              size: "14px"
            })
          ])
        ])
      ]),
      _createVNode(_component_settings_modal, {
        class: "modal-settings",
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal())),
        user: _ctx.user,
        tabs: _ctx.tabs
      }, null, 8, ["user", "tabs"]),
      _createVNode(_component_TableSetting, {
        class: "mt-4",
        prop_table_data: _ctx.setting,
        columns: [
          { name: 'USU_NOME', header: 'Nome' },
          { name: 'USU_LOGIN', header: 'Login' },
        ],
        onSaveAlert: _ctx.timeAlert,
        onOpenUser: _cache[3] || (_cache[3] = (val) => _ctx.openModal(val)),
        tablestyle: "main-table",
        tabletype: "user",
        showHeaders: true
      }, null, 8, ["prop_table_data", "onSaveAlert"])
    ])
  ]))
}